import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../../commonComponents/AddBtn'
import List from '../../../../commonComponents/List'
import { CustomLoader } from '../../../../commonComponents/formComponents/loader'
import ContainerDetails from '../../itemsTab/containerDetails'
import { TranslateContext } from '../../TranslateContext'
import { useHeaderContainer } from '../../../hooks/useHeaderContainer'

const Container = (props) => {

  const [isLoading, addItem, updateItem, saveItem, deleteItem] = useHeaderContainer('header')

  const containerInfolist = useSelector((state) => state.Shipment?.transportation?.containers) || []
  
  const { isFormEnabled } = props

  const renderItem = useCallback(
    (item) => {
      return (
        <ContainerDetails
          key={item.id}
          item={item}
          updateData={updateItem}
          deleteData={deleteItem}
          saveData={saveItem}
        />
      )
    },
    [updateItem, saveItem, deleteItem]
  )

  const translate = React.useContext(TranslateContext).translate

  return (
    <div>
      <div style={{ textTransform: 'uppercase', textAlign: 'center' }}>
        <span>
          <strong> {translate("CONTAINERS", { ns: ["default", "header"] })}</strong>
        </span>
      </div>
      <div style={{ border: '1px solid #1765AE' }}>
        <div className='cont_row cont_row--head'>
          <div className='cont_col cont_col--th pl-2' style={{paddingLeft:'20px'}}>
            {translate("7/10 CONTAINER")}
          </div>
          <div className='cont_col cont_col--th pl-2' style={{paddingLeft:'15px'}}>
            {translate("7/18 SEAL", { ns: ["default", "header"] })}
          </div>
          <div className='cont_col cont_col--th pl-2'>
            {translate("7/11 SIZE AND TYPE", { ns: ["default", "header"] })}
          </div>
          <div className='cont_col cont_col--th pl-2'>
            {translate("QTY", { ns: ["default", "header"] })}
          </div>
          <div className='cont_col cont_col--th pl-2'>
            {translate("WEIGHT", { ns: ["default", "header"] })}
          </div>
          <div className='cont_col cont_col--th pl-2'></div>
        </div>
        <Form.Group className='float-container'>
          <List
            dataSource={containerInfolist}
            isFormEnabled={isFormEnabled}
            renderItem={renderItem}
          />

          {isLoading && <CustomLoader />}
          {<AddBtn
            id={`container-add`}
            disabled={isFormEnabled}
            onClick={addItem}
            text={translate("ADD")}
            style={{ marginBottom: '10px' }}
          >
          </AddBtn>}
        </Form.Group>
      </div>
    </div>
  )
}

export default React.memo(Container)
